module.exports = __webpack_public_path__ + "static/img/new_float_code_1.e100a63.png";